var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBrush5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18h-5c-.55 0-1.05-.22-1.41-.59-.37-.36-.59-.86-.59-1.41 0-1.03.8-1.89 1.81-1.99.06-.01.12-.01.19-.01h15c.07 0 .13 0 .19.01.48.04.9.25 1.22.58.41.4.63.97.58 1.59-.09 1.05-1.04 1.82-2.1 1.82H14.5v1.5a2.5 2.5 0 0 1-5 0V18zM13.25 2c-.28 0-.5.22-.5.5V4c0 .41-.34.75-.75.75-.09 0-.17-.02-.25-.05-.29-.1-.5-.38-.5-.7V2.5c0-.28-.22-.5-.5-.5H9.24c-.28 0-.5.22-.5.5V7c0 .41-.34.75-.75.75s-.75-.34-.75-.75V2.5c0-.27-.2-.48-.47-.5h-.03a2.992 2.992 0 0 0-2.91 3.3l.37 6.75c.03.53.47.95 1 .95h13.6c.53 0 .97-.42 1-.95l.37-6.75c.18-1.77-1.21-3.3-2.98-3.3h-3.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBrush5);
export default __webpack_public_path__ + "static/media/vuesax-bold-brush_5.fcc37e03db84bceca6861bdc19691fa2.svg";
export { ForwardRef as ReactComponent };